import { useMutation } from '@tanstack/react-query';
import { createLead } from '@Services/init/welcome.api.ts';
import { useBoundStore } from '@Store/index.ts';
import { updateCustomerDataFromServer } from '@Services/init/util.ts';
import {
  getFlowId,
  identifyGA4User,
  setGA4UserProperties,
} from '@Services/analytics/analytics.service';
import { identifyLogRocketUser } from '@Services/analytics/logrocket.service';
import {
  setPeopleProperty,
  identifyTrackingServiceUser,
} from '@Services/analytics/tracking.service';
import { LiliPlanType } from '@Pages/happyFlowPages/planSelection/types';
import { useWelcomeAnalytics } from '@Pages/passwordless/welcome/WelcomeAnalytics';

export const useCreateLead = () => {
  const customerData = useBoundStore((state) => state.customer);
  const setCustomerData = useBoundStore((state) => state.setCustomerData);
  const { reportStartOnboarding } = useWelcomeAnalytics();
  const { isFromLiliApp } = useBoundStore((state) => state.onboardingSlice);

  return useMutation({
    mutationFn: createLead,
    onSuccess: (data) => {
      identifyTrackingServiceUser(data.externalId);
      identifyGA4User(data.externalId);
      reportStartOnboarding();
      const analyticsProps = {
        canSelectPlan: true,
        isFromLiliApp,
        defaultPlanSelected: LiliPlanType.SMART, // @TODO: check with Nir.
        flowId: getFlowId(),
      };
      setPeopleProperty(analyticsProps);
      const updatedCustomerData = {
        ...customerData,
        ...data,
        customerId: data?.externalId,
      };
      setCustomerData(updatedCustomerData);
      updateCustomerDataFromServer(data, updatedCustomerData);
      identifyLogRocketUser(data.externalId);
      setGA4UserProperties();
    },
  });
};
